import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import React, { Children, cloneElement, isValidElement, ReactNode, forwardRef, useState } from 'react';
import { DropdownMenuContent } from './DropdownMenuContent';
import { DropdownMenuTrigger } from './DropdownMenuTrigger';
import { useSubMenu } from '../../SubMenuContext';

interface DropdownMenuProps {
  children: ReactNode;
  isOpen?: boolean;
  setIsOpen?: (open: boolean) => void;
}

interface ItemMenuProps {
  isOpen: boolean;
}

export const DropdownMenu = forwardRef<HTMLDivElement, DropdownMenuProps>(
  ({ children, isOpen: controlledIsOpen, setIsOpen: controlledSetIsOpen }, ref) => {
    const { clearSub } = useSubMenu();

    // Estado interno para o modo não-controlado
    const [uncontrolledIsOpen, setUncontrolledIsOpen] = useState(false);

    // Decide se está controlado ou não
    const isControlled = controlledIsOpen !== undefined && controlledSetIsOpen !== undefined;

    const isOpen = isControlled ? controlledIsOpen : uncontrolledIsOpen;
    const setIsOpen = isControlled ? controlledSetIsOpen : setUncontrolledIsOpen;

    const handleOpenChange = (open: boolean) => {
      setIsOpen?.(open);
    };

    const sidebarElements = Children.map(children, (child) => {
      if (!isValidElement(child)) return null;

      if (child.type === DropdownMenuContent || child.type === DropdownMenuTrigger) {
        return cloneElement(child as React.ReactElement<ItemMenuProps>, {
          isOpen,
        });
      }

      return null;
    });

    return (
      <DropdownMenuPrimitive.Root
        open={isOpen}
        onOpenChange={(state) => {
          handleOpenChange(state);
          if (!state) clearSub?.();
        }}
      >
        <div className="flex" ref={ref}>
          {sidebarElements}
        </div>
      </DropdownMenuPrimitive.Root>
    );
  }
);

DropdownMenu.displayName = 'DropdownMenu';
